import React, { useContext, useEffect, useState } from "react";
import OfferBenefitCard from "../components/OfferBenefitCard";
import axios from "axios";
import { StoreContext } from "../context/StoreContext";

function OfferBenefits() {
  const { accessToken, orderId, userId } = useContext(StoreContext);
  const [offerDetails,setOfferDetails] = useState([]);

  const fetchOffer = async () => {
    try {
      console.log("O",orderId)
      if (orderId){
      const response = await axios.get(
        `/api/payment/benefits/offers/applicable/OR241013T121632M00830`,
        {
          headers: {
            "auth-token": accessToken,
            "user-id": userId,
          },
        }
      );
      console.log("Offer",response.data)
      console.log("title",response.data.data[0].amount)
      setOfferDetails(response.data.data);
    }
    } catch (error) {
      console.log("Error in fetching Offer",error)
    }

  };
  useEffect(()=>{
    fetchOffer();
  },[orderId])

  return (
    <div className="pt-24 flex flex-col w-full h-full items-center bg-[#FBFCFF]">
      <h2 className="text-[#171725] text-2xl md:text-3xl">Offers & Benefits</h2>
      <div className="pt-3 md:pt-5 pb-2 text-lg text-[#171725] px-2 md:px-5 lg:px-5 w-full h-full">
        <h3 className="text-xl md:text-2xl">
          Exclusive offers and benefits for you
        </h3>
        <div className="mt-3">
          {offerDetails.map((item,index) => (
               <OfferBenefitCard 
               key={index}
               amount={item.amount}
               title={item.title}
               subtitle={item.subtitle}
               termsConditions={item.termsConditions}
               offerId={item.offerId}
               />
          ))}
         
        </div>
      </div>
    </div>
  );
}

export default OfferBenefits;
